import { dynamicTranslateKeys } from '@utils/constants/dynamic-translate-keys';
import { message } from '@utils/helper';
import { BadResponseErrorType, BadResponseType } from '@utils/models/bad-response-type';
import i18next from 'i18next';
import { ZodError } from 'zod';

import { showMessage } from './showMessage';

const errorMessages = {
  uz: 'Xatolik mavjud',
  ru: 'Есть ошибка',
  en: 'There is an error',
  kr: 'Хатолик мавжуд',
  tr: 'Bir hata var',
  tj: 'Хатогие ҳаст',
  ky: 'Xаталык бар'
};

export const generateErrorMessage = (err: BadResponseErrorType['errorMessage']) => {
  const args = err?.args || {};
  let messageTemplate = err?.message || 'Xatolik mavjud';
  const translateKey = dynamicTranslateKeys[err?.messageCode]?.key || dynamicTranslateKeys[1000].key;

  for (const key in args) {
    messageTemplate = messageTemplate.replace(new RegExp(key, 'g'), `{{${key}}}`);
  }

  return i18next.t(`global.${translateKey}`, args);
};

export const baseErrorHandler = (payload: unknown): void => {
  const err = (
    payload as {
      response: BadResponseType;
    }
  )?.response;
  const accept = err?.data?.accept;

  if (err?.status === 401) return;

  if (typeof accept === 'boolean') {
    if (accept) {
      showMessage(err?.data?.message as Record<string, string>, accept);
    } else {
      message.error(generateErrorMessage(err?.data?.errorMessage as BadResponseErrorType['errorMessage']));
    }

    return;
  }

  if (err instanceof ZodError) {
    // eslint-disable-next-line no-console
    console.error(err?.message);
  } else showMessage(errorMessages, false);
};
